<template>
  <div class="hlj-index">
    <hljHeader></hljHeader>
    <div class="index-title">

    </div>
    <div class="link-list">
      <div class="link-item pxzt" @click="$router.push(`/${school_code}/custom/hljdypx/pxztList`)"></div>
      <div class="link-item jjfz" @click="$router.push(`/${school_code}/custom/hljdypx/jjfzList`)"></div>
    </div>
    <div class="index-footer">
      <img class="sydw" src="../../../assets/custom/hlj/index/footer-icon.png" alt="">
      <span>黑龙江农业经济职业学院版权所有</span>
      <span>中国黑龙江省牡丹江市西安区</span>
      <span>邮编：157041</span>
      <span>电话：0453-6402306</span>
      <span>黑ICP备06005807号-1</span>
    </div>
  </div>
</template>

<script>
import utils from "../../../config/utils"
import hljHeader from "../../../components/Custom/hlj/hlj_header.vue"
export default {
  data() {
    return {
      utils,
       school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
    }
  },
  components: {
    hljHeader
  },
  created() {
    this.utils.setFonts()
  },
  mounted() {
    window.onresize = () => {
      this.utils.setFonts()
    }
  }
}
</script>
<style lang="less" scoped>
.hlj-index {
  width: 100%;
  height: 100vh;
  background-image: url("../../../assets/custom/hlj/index/index-bg.png");
  background-size: cover;
  background-position: center;
  position: relative;
  .index-title {
    width: 8.43rem;
    height: 1.94rem;
    background-image: url("../../../assets/custom/hlj/index/index-title.png");
    background-size: cover;
    background-position: center;
    margin: 7.7vw auto 0;
  }
  .link-list {
    display: flex;
    justify-content: space-between;
    width: 12rem;
    margin: 0 auto;
    margin: 4.6vw auto 0;
    .link-item {
      width: 5.73rem;
      height: 2rem;
      background-size: cover;
      background-position: center;
      cursor: pointer;
      &.pxzt {
        background-image: url("../../../assets/custom/hlj/index/pxzt.png");
      }
      &.jjfz {
        background-image: url("../../../assets/custom/hlj/index/jjfz.png");
      }
    }
  }
  .index-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    bottom: 3vw;
    .sydw {
      width: 0.48rem;
      margin-right: .2rem;
    }
    span {
      font-weight: bold;
      margin: 0 0.05rem;
      font-size: 0.16rem;
      color: #ffffff;
    }
  }
}
</style>